import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import { platformGet, platformPatch } from "@/common/api/rest/platform";

import type { TranslationFieldsType } from "@/common/types/translation";
import type { PlatformType } from "@/common/types/platform";

import FormPlatform from "@/components/forms/form-platform.vue";
import ListTranslate from "@/components/lists/list-translate.vue";
import { breadcrumbSimple, iconMenu, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const { t, locale } = useI18n();
const router = useRouter();
const route = useRoute();

const translationFields = ref<TranslationFieldsType[]>([
  {
    type: "input",
    field: "name",
    label: "common.labels.name",
    value: "",
  },
  {
    type: "textarea",
    field: "description",
    label: "common.labels.description",
    value: "",
  },
]);

const platformData = ref<PlatformType | null>(null);

const loading = ref(true);

const platformId = computed(() => route.params.platform as string);

const breadcrumbList = computed(() => [
  {
    key: "register",
    label: t("common.labels.registrations"),
    url: "/register",
  },
  {
    key: "platform",
    label: t("common.labels.platforms"),
    url: `/register/platform`,
  },
  {
    key: "edit",
    label: platformData.value?.name ?? "...",
  },
]);

const menuList = computed(() => [
  {
    key: "platform",
    icon: "home-line",
    label: t("platform.labels.platform"),
    url: `/register/platform/${platformId.value}/edit`,
  },
  {
    key: "slug",
    icon: "field",
    label: t("slug.labels.slugs"),
    url: `/register/platform/${platformId.value}/slug`,
  },
]);

function back() {
  router.push("/register/platform");
}

function changeMenu(url: string) {
  router.push(url);
}

// PLATFORM
function fetchPlatform() {
  platformGet(platformId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        platformData.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      loading.value = false;
    });
}

function patchData(payload: Partial<PlatformType>) {
  platformPatch(platformId.value, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchPlatform();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

onMounted(() => {
  fetchPlatform();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "platform",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("platform.labels.edit_platform")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(iconMenu), {
          tabs: menuList.value,
          active: "platform",
          size: "3rem",
          onSelected: _cache[1] || (_cache[1] = ($event: any) => (changeMenu($event)))
        }, null, 8, ["tabs"]),
        (_openBlock(), _createBlock(FormPlatform, {
          key: loading.value ? 0 : 1,
          "is-patch": true,
          data: platformData.value,
          "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => (patchData($event)))
        }, null, 8, ["data"])),
        _createVNode(ListTranslate, {
          "owner-id": platformId.value,
          language: _unref(locale).toLowerCase(),
          fields: translationFields.value
        }, null, 8, ["owner-id", "language", "fields"])
      ])
    ])
  ]))
}
}

})